export enum ConsentFormSignerType {
  PROSPECT = 1,
  GAURDIAN1,
  GAURDIAN2,
}

export enum ConsentFormContactType {
  EMAIL = 1,
  WHATSAPP,
}

export type ProspectConsentFormDTO = {
  prospectConsentFormId: number;
  prospectId: number;
  signedFileResourceUrl?: string;
  prospectSigningUrl?: string;
  prospectSignedTs?: Date;
  completedTs?: Date;
  guardianSignaturesRequired: boolean;
};

export type ConsentFormGuardianSignersDTO = {
  guardian1?: ConsentFormSignerDTO;
  guardian2?: ConsentFormSignerDTO;
};

export type ConsentFormSignerDTO = {
  signerTypeId: ConsentFormSignerType;
  contactTypeId: ConsentFormContactType;
  email?: string;
  whatsappCountryId: number;
  whatsapp: string;
  required: boolean;
  signedTs: Date;
};
